<!--
 * @Author: awu
 * @Date: 2020-11-12 21:14:13
 * @LastEditors: awu
 * @LastEditTime: 2020-12-09 22:42:34
 * @Description: 展会首页
-->
<template>
    <div style="width:100%;height:100%;">
        <div  class="area" >
           <div>
                <CHeader  :hideMenu="hideMenu" v-show="header"/>
                <div v-if="headerimg && exhibition_id==21" class="area-logo">
                    <img src="../../assets/area/logo.png" alt="" />
                </div>
           </div>
            <div class="area-home" @click="goPage('/exhibition')" v-show="goPageBtn">
                <img src="../../assets/area/home.png" alt="" />
            </div>
            <div class="area-btnWarpper"  v-show="btnWrapper">
                <div
                    class="area-btnWarpper-btn"
                    v-for="(item, index) in btn"
                    :key="index"
                    @mouseenter="mouseenter(item, index)"
                    @mouseleave="mouseleave"
                    :class="{ active:currentIndex === index , zxt:currentIndex == 0 || currentIndex == '',hyt:currentIndex == 2}"
                    @click="goPath(item,index)"
                >
                    <img :src="item.img" alt="" />
                    <span class="area-btnWarpper-btn-name"  :class="{ active:currentIndex === index }">{{ item.text }}</span>
                </div>
            </div>
            <div v-for="(item, index) in btnWarpper" class="imgset" :class="item.className" :key="item.text">
                <div class="imgWarp" @mouseenter="isShowOutSide(item, 1, index)" @mouseleave="isShowOutSide(item, 2, index)" @click="goPath(item,index)">
                    <img :src="item.img" alt=""  style="width: 30px;height: 30px" />
                </div>
                <div class="outSide" v-show="ishowList[index]">{{ item.text }}</div>
            </div>
            <!-- <template>
                <div class="hotarea hotarea-zhanqu" @click="goPath({ path: '/area/zhanqu?exhibition_id=' + exhibition_id })"></div>
                <div class="hotarea hotarea-conference" @click="goPath({ path: '/area/conference?exhibition_id=' + exhibition_id })"></div>
                <div class="hotarea hotarea-schedule" @click="goPath({ path: '/area/consult' })"></div>
            </template> -->
            <Schedule v-if="scheduleFlag" :exhibitionId="exhibition_id" @noShowSchedule="noShowSchedule" />
            <!-- <VideoCom v-if="videoFlag" :src="videoSrc" @close="close" /> -->
            <router-view></router-view>
        </div>
        
    </div>
</template>

<script>
import { changeLanuage } from "@/lang";
import CHeader from "../exhibition/components/Headers";
import LoginBtn from "@/components/LoginButton";
import { mapState } from "vuex";
import Schedule from "../../components/schedule";
import VideoCom from "../../components/video";
import api from "@/api";
import Lockr from "lockr";
import { INDEX_TRANS_VIDEO_URL, EXHIBITION_ID } from "../../assets/common/data";

export default {
    components: {
        LoginBtn,
        Schedule,
        VideoCom,
        CHeader
    },
    computed: {
        areaIndex() {
            return this.$t("areaIndex");
        },
        btn() {
            // console.log(this.currentBtnIndex);
            // return [
            //     {
            //         img: require("../../assets/area/btn1.png"),
            //         // img: require("../../../static/zxt.png"),
            //         path: "/area/consult",
            //         text: this.$t("areaIndex").zxt
            //     },
            //     {
            //         img: require("../../assets/area/btn2.png"),
            //         // img: require("../../../static/zlt.png"),
            //         path: "/area/zhanqu?exhibition_id=" + this.exhibition_id,
            //         text: this.$t("areaIndex").zlt
            //     },
            //     {
            //         img: require("../../assets/area/btn3.png"),
            //         // img: require("../../../static/hyt.png"),
            //         path: "/area/conference?exhibition_id=" + this.exhibition_id,
            //         text: this.$t("areaIndex").hyt
            //     }
            // ];
            // alert(this.currentBtnIndex,'333')
            if(this.currentIndex == 0){
                return [
                    {
                        img: require("../../assets/zxt-un.png"),
                        // img: require("../../../static/zxt.png"),
                        path: "/area/consult",
                        text: this.$t("areaIndex").zxt
                    },
                    {
                        img: require("../../assets/zlt.png"),
                        // img: require("../../../static/zlt.png"),
                        path: "/area/zhanqu?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").zlt
                    },
                    {
                        img: require("../../assets/hyt.png"),
                        // img: require("../../../static/hyt.png"),
                        path: "/area/conference?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").hyt
                    }
                ];
            }else if(this.currentIndex == 1){
                return [
                    {
                        img: require("../../assets/zxt.png"),
                        // img: require("../../../static/zxt.png"),
                        path: "/area/consult",
                        text: this.$t("areaIndex").zxt
                    },
                    {
                        img: require("../../assets/zlt-un.png"),
                        // img: require("../../../static/zlt.png"),
                        path: "/area/zhanqu?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").zlt
                    },
                    {
                        img: require("../../assets/hyt.png"),
                        // img: require("../../../static/hyt.png"),
                        path: "/area/conference?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").hyt
                    }
                ];
            }else if(this.currentIndex == 2){
                return [
                    {
                        img: require("../../assets/zxt.png"),
                        // img: require("../../../static/zxt.png"),
                        path: "/area/consult",
                        text: this.$t("areaIndex").zxt
                    },
                    {
                        img: require("../../assets/zlt.png"),
                        // img: require("../../../static/zlt.png"),
                        path: "/area/zhanqu?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").zlt
                    },
                    {
                        img: require("../../assets/hyt-un.png"),
                        // img: require("../../../static/hyt.png"),
                        path: "/area/conference?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").hyt
                    }
                ];
            }else{
                
                return [
                    {
                        img: require("../../assets/zxt.png"),
                        // img: require("../../../static/zxt.png"),
                        path: "/area/consult",
                        text: this.$t("areaIndex").zxt
                    },
                    {
                        img: require("../../assets/zlt.png"),
                        // img: require("../../../static/zlt.png"),
                        path: "/area/zhanqu?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").zlt
                    },
                    {
                        img: require("../../assets/hyt.png"),
                        // img: require("../../../static/hyt.png"),
                        path: "/area/conference?exhibition_id=" + this.exhibition_id,
                        text: this.$t("areaIndex").hyt
                    }
                ];
            }
        },
        lan() {
            return [
                {
                    text: "简体中文",
                    type: "zh"
                },
                {
                    text: "English",
                    type: "en"
                }
            ];
        },
        btnWarpper() {
            return [
                {
                    text: this.$t("areaIndex").mpj,
                    className: "area-card",
                    img: require("../../../static/card.png"),
                    showChildId: 4,
                    isShow: false
                },
                {
                    text: this.$t("areaIndex").scj,
                    className: "area-collect",
                    img: require("../../../static/store.png"),
                    showChildId: 3,
                    isShow: false
                },
                {
                    text: this.$t("areaIndex").rc,
                    className: "area-schedule",
                    img: require("../../../static/rili.png"),
                    path: "/area/consult/rcap",
                    isShow: false
                }
            ];
        }
    },
    mounted() {
        const key = "isShowVideo_" + this.exhibition_id ;
        // 控制视频只播放一次
        // this.isShow = !!sessionStorage.getItem(key) || false;
        this.language = localStorage.getItem("language") || "zh";
        this.getUserInfo();
        this.scheduleFlag = false;
        this.videoFlag = false;
        // alert(this.currentIndex)  
        // switch (Number(this.exhibition_id)) {
        //   case EXHIBITION_ID.EDUCATION:
        //       this.mainVideoSrc = INDEX_TRANS_VIDEO_URL.EDUCATION;
        //       break;
        //   case EXHIBITION_ID.TRADE:
        //       this.mainVideoSrc = INDEX_TRANS_VIDEO_URL.TRADE;
        //       break;
        //   default:
        //       break;
        // }

    },
    watch: {
        $route: {
            handler(route) {
                // console.log(route)
                this.exhibition_id = this.$route.query.exhibition_id;
                // this.status = this.$route.query.status
                // console.log(route.path,route.query.exhibition_id);
                // if(route.query.exhibition_id == 23 ||route.query.exhibition_id == 33 || route.query.exhibition_id == 38 || route.query.exhibition_id == 34 || route.query.exhibition_id == 41){
                //     this.btnWrapper = false
                // }
                if(route.query.exhibition_id == 23 || route.query.exhibition_id == 33 || route.query.exhibition_id == 38 || route.query.exhibition_id == 34 || route.query.exhibition_id == 41){
                    this.schedule = false
                }
                if(route.query.exhibition_id == 21 || route.query.exhibition_id == 25 || route.query.exhibition_id == 31 || route.query.exhibition_id == 50 || route.query.exhibition_id == 60 || route.query.exhibition_id == 82){
                    this.btnWrapper = true
                }else{
                    this.btnWrapper = false
                }
                if(route.path == "/area/ztDetail"){
                    this.header = true
                }else{
                    this.header = true
                }
                if(route.path == "/area/ztDetail"){
                    this.headerimg = false
                    this.goPageBtn = true
                }else{
                    this.headerimg = true
                }
                console.log(route.path,'path')
                if(route.path == "/area/consult"){
                    this.currentIndex = 0
                    this.goPageBtn = true
                }
                if(route.path == "/area/zhanqu"){
                    this.goPageBtn = false
                    this.currentIndex = 1
                }
                if(route.path == "/area/conference"){
                    this.currentIndex = 2
                    this.goPageBtn = true
                }
                if(route.path == "/area/bigconference"){
                    this.currentIndex = 2
                }
                if(route.path == "/area/smallconference"){
                    this.currentIndex = 2
                }

            },
		    immediate: true,
        },
        
    },
    destroyed() {
        this.isShow = false;
    },
    data() {
        return {
            schedule: true,
            exhibition_id: '',
            currentIndex: '',
            goPageBtn: true,
            headerimg: true,
            header: true,
            btnWrapper: true,
            // status: '',
            mouseenterNum: -1,
            lanmouseenterNum: 0,
            isShowLan: false,
            // language: "",
            hideMenu: false,
            ishowList: {
                0: false,
                1: false,
                2: false
            },
            searchWord: "",
            searchList: [],
            scheduleFlag: false,
            hasData: false,
            isShow: false,
            videoFlag: false,
            currentBtnIndex: ''
        };
    },
    methods: {
        handleCloseSearch() {
            this.hasData = false;
        },
        handleSearch(e) {
            api.getExhibitorList({
                search: this.searchWord || "",
                exhibition_id: this.exhibition_id
            }).then((res) => {
                if (res.res === 1) {
                    this.searchList = res.list || [];
                    this.hasData = this.searchList.length > 0 ? "true" : "false";
                }
            });
        },
        getCompany(company_id) {
            for (let key in areaData) {
                const arr = areaData[key];
                for (let index = 0; index < arr.length; index++) {
                    const item = arr[index];
                    const { companyList } = item;
                    for (let j = 0; j < companyList.length; j++) {
                        if (companyList[j].company_id === company_id) {
                            return companyList[j];
                        }
                    }
                }
            }
        },
        handleClickItem(item) {
            this.hasData = false;
            const chooseCompany = this.getCompany(item.company.id);
            if (chooseCompany && chooseCompany.bc) {
                Lockr.set("bc", chooseCompany.bc);
            }
            if (this.$route.path === "/area/ztDetail") {
                if (this.$route.query.company_id == item.company.id) {
                    return;
                }
                this.$forceUpdate();
            }
            this.$router.push({
                path: "/area/ztDetail",
                query: {
                    company_id: item.company.id,
                    instance_id: item.vhall.id,
                    exhibition_id: this.exhibition_id,
                    t: Date.now()
                }
            });
        },
        playVideo() {
            this.videoFlag = true;
        },
        close() {
            this.videoFlag = false;
        },
        getUserInfo() {
            if (localStorage.getItem("access_token")) {
                api.getUserInfo().then((res) => {
                    if (res.res === 1) {
                        this.$store.commit("setState", {
                            userInfo: res.data
                        });
                    }
                });
            }
        },
        goPage(path) {
            this.$router.push(path);
        },
        mouseenter(item, index) {
            this.mouseenterNum = index;
        },
        mouseleave() {
            this.mouseenterNum = -1;
        },
        lanmouseenter(item, index) {
            this.lanmouseenterNum = index;
        },
        chooseLan(item) {
            this.isShowLan = false;
            this.toggleLanguage(item.type);
        },
        showLanBox() {
            this.isShowLan = !this.isShowLan;
        },
        toggleLanguage(type) {
            if (this.language === type) return;
            this.language = type;
            changeLanuage(type);
        },
        goPath(item, index) {
            console.log(item, index)
            this.currentIndex = index
            // alert(this.currentBtnIndex)
            if (!item.path && item.showChildId) {
                this.$store.commit("setState", {
                    showUserModal: true,
                    hideUserModalSideBar: true,
                    showChildId: item.showChildId
                });
                return;
            }

            if (item.path == "/area/consult/rcap") {
                this.scheduleFlag = !this.scheduleFlag;
                return;
            }
            this.$router.push({
                path: item.path,
                query: { exhibition_id: this.exhibition_id}
            });
        },
        noShowSchedule() {
            this.scheduleFlag = false;
        },
        isShowOutSide(item, type, index) {
            if (type == 1) {
                this.ishowList[index] = true;
            } else if (type == 2) {
                this.ishowList[index] = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width:1440px){
    .area-logo{
        top: 100px
    }
}
@media screen and (min-width:1440px) and (max-width:1600px){
    .area-logo{
        top: 100px
    }
}
@media screen and (min-width:1600px){
    .area-logo{
        top: 160px
    }
}
#videoPlay {
    width: 100%;
    height: 100%;
}
// .area-logo{
//     width: 366px;
//     height: 125px;
//     background: rgba(255, 255, 255, 0.65);
//     border-radius: 0px 0px 42px 42px;
//     opacity: 0.92;
//     // position: absolute;
//     z-index: 5;
//     // top: 9.8%;
//     // left: 22px;
//     box-sizing: border-box;
//     padding: 11px 48px 13px 56px;
//     > img {
//         height: 100%;
//         width: 100%;
//     }
// }
.area {
    width: 100%;
    height: 100vh;
    // position: relative;
    //background: url("../../assets/area/indexBc.png");
    background-size: 100% 100%;
    .play {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #595b5f;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 57%;
        left: 50%;
        cursor: pointer;
    }
    // &-logo{
    //     width: 366px;
    //     height: 125px;
    //     background: rgba(255, 255, 255, 0.65);
    //     border-radius: 0px 0px 42px 42px;
    //     opacity: 0.92;
    //     // position: absolute;
    //     z-index: 5;
    //     // top: 9.8%;
    //     // left: 22px;
    //     box-sizing: border-box;
    //     padding: 11px 48px 13px 56px;
    //     > img {
    //         height: 100%;
    //         width: 100%;
    //     }
    // }
    &-logo {
        // width: 366px;
        // height: 100px;
        // background: rgba(255, 255, 255, 0.65);
        // border-radius: 0px 0px 42px 42px;
        // opacity: 0.92;
        // box-sizing: border-box;
        padding: 0px 48px 5px 56px;
        width: 415px;
        height: 100px;
        opacity: 0.7;
        background: #ffffff;
        border-radius: 0px 30px 30px 0px;
        position: absolute;
        z-index: 2;
        // top:160px;
        > img {
            max-height: 90px;
            max-width: 100%;
        }
    }
    &-search {
        width: 310px;
        height: 45px;
        background: #ffffff;
        border-radius: 17px;
        position: absolute;
        z-index: 5;
        top: 49px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 12px;
        &.active {
            border-radius: 17px 17px 0 0;
        }
        input {
            flex: 1;
        }
        .icon {
            margin-left: 10px;
            width: 24px;
            height: 24px;
            cursor: pointer;
            margin-top: 2px;
        }
        .nodata {
            position: absolute;
            bottom: -56px;
            left: 0;
            right: 0;
            height: 47px;
            line-height: 47px;
            background: rgba(0, 0, 0, 0.45);
            color: rgba(255, 255, 255, 1);
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-radius: 13px;
        }
        .search-lists {
            position: absolute;
            border-radius: 0px 0px 13px 13px;
            bottom: 0px;
            left: 0;
            right: 0;
            max-height: 300px;
            overflow-y: auto;
            background-color: #fff;
            transform: translateY(100%);
        }
        .search-item {
            height: 33px;
            font-weight: 500;
            line-height: 33px;
            padding: 0 23px;
            color: rgba(9, 70, 140, 1);
            cursor: pointer;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover {
                background-color: rgba(9, 70, 140, 0.23);
            }
        }
    }
    &-user {
        width: 158px;
        height: 45px;
        background: #09468c;
        border-radius: 21px;
        position: absolute;
        z-index: 6;
        top: 49px;
        right: 103px;
    }
    &-lan {
        width: 47px;
        height: 45px;
        background: #ffffff;
        box-shadow: 0px 7px 14px 0px rgba(108, 156, 188, 0.14);
        border-radius: 21px;
        position: absolute;
        z-index: 5;
        top: 49px;
        right: 37px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &-box {
            width: 211px;
            height: 121px;
            background: #ffffff;
            border-radius: 21px;
            position: absolute;
            top: 137px;
            right: 50px;
            box-sizing: border-box;
            z-index: 2;
            // padding: 0 12px;
            > div {
                box-sizing: border-box;
                height: 50%;
                border-bottom: 1px solid #09468c;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 21px 21px 0 0;
                cursor: pointer;
            }
            div:last-of-type {
                border: 0;
                border-radius: 0 0 21px 21px;
            }
            .active {
                background-color: rgba(9, 70, 140, 0.1);
            }
        }
    }
    &-home {
        width: 58px;
        height: 58px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        z-index: 5;
        bottom: 20px;
        left: 37px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    &-btnWarpper {
        width: 480px;
        height: 60px;
        background: #FFFFFF;
        box-shadow: 5px 5px 20px 0px rgba(6, 58, 120, 0.5);
        border-radius: 30px;
        // width: 520px;
        // height: 56px;
        // background: #ffffff;
        // box-shadow: 5px 5px 20px 0px rgba(6, 58, 120, 0.5);
        // border-radius: 30px;
        position: absolute;
        z-index: 5;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        // padding: 7px 39px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        &-btn {
            width: 160px;
            height: 60px;
            // border-radius: 16px;
            // // opacity: 0.1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 600;
            color:#49546B;
            cursor: pointer;
            > img {
                margin-right: 6px;
                width: 30px;
            }
            &-name{
                color: #49546B;
                font-size: 16px;
                line-height: 22px;
            }
            .active{
                color: #fff;
            }
        }
        .hyt{
            border-radius: 0px 30px 30px 0px
        }
        .zxt{
            border-radius: 30px 0 0 30px;
        }
        .active {
            background-color:#194B96;
        }
    }
    &-card {
        width: 58px;
        height: 58px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        z-index: 5;
        bottom: 20px;
        right: 271px;
        cursor: pointer;
    }
    &-collect {
        width: 58px;
        height: 58px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        z-index: 5;
        bottom: 20px;
        right: 162px;
        cursor: pointer;
    }
    &-schedule {
        width: 58px;
        height: 58px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        z-index: 5;
        bottom: 20px;
        right: 50px;
        cursor: pointer;
    }
    .imgset {
        display: flex;
        align-items: center;
        justify-content: center;
        .imgWarp {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            > img {
                width: 24px;
            }
        }
        .outSide {
            min-width: 140px;
            height: 69px;
            line-height: 64px;
            text-align: center;
            font-weight: 600;
            font-size: 18px;
            color: #09468c;
            position: absolute;
            top: -88px;
            left: 50%;
            transform: translateX(-50%);
            // background-color: #fff;
            background: url("../../assets/area/talk.png");
            background-size: 100% 100%;
            z-index: 9;
            white-space: nowrap;
        }
    }
    .hotarea {
        width: 80px;
        height: 80px;
        position: fixed;
        background: url("~@/assets/hot.gif") no-repeat center;
        background-size: 100% 100%;
        cursor: pointer;
        &-zhanqu {
            top: 42.78%;
            left: 26.04%;
        }
        &-conference {
            top: 42.78%;
            right: 25.52%;
        }
        &-schedule {
            top: 65.31%;
            left: 56%;
            transform: translateX(-50%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/area/index.vue